export const TENANT_UUID_KEY = 'tenant-uuid';

export const setTenantUuid = (uuid: string | undefined) => {
  if (uuid) {
    localStorage.setItem(TENANT_UUID_KEY, uuid);
  } else {
    localStorage.removeItem(TENANT_UUID_KEY);
  }
};

export const getTenantUuid = (): string => localStorage.getItem(TENANT_UUID_KEY) ?? '';
